export default "__VITE_ASSET__BfnbW6$H__"